// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function costaRicanOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'cr',
    document: userInputValues['costaRicanDocument'],
    zipcode: userInputValues['costaRicanZipcode'],
    state: userInputValues['costaRicanState'],
    city: userInputValues['costaRicanCity'],
    address: userInputValues['costaRicanAddress'],
    street_number: userInputValues['costaRicanStreetNumber'],
    street_complement: userInputValues['costaRicanStreetComplement'],
    phone_number: userInputValues['costaRicanPhoneNumber'],
  };
}
